import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const Assessments = lazyPage(() => import('@/pages/assessment/Assessments'));
const EnterMarks = lazyPage(() => import('@/pages/assessment/EnterMarks'));

export const assessmentRoutes: AppRoute[] = [
  {
    path: 'assessment',
    title: 'Assessment',
    children: [
      { path: '', title: 'Assessment', component: ModuleMenu },
      { path: 'assessments', title: 'Assessments', component: Assessments },
      { path: 'marks', title: 'Enter Marks', component: EnterMarks },
    ],
  },
];
